
const state = {
  isLoading: false,
  loadingMessages: '',
}

const mutations = {
  setLoadingStatus(state, status){
    state.isLoading = status.loading
    state.loadingMessages = status.message
  },
  clearLoading(state){
    state.isLoading = false
    state.loadingMessages = ''
  }
}

export default {
  namespaced: true,
  state,
  mutations,
}